import {AdBannerEvent, BigFarm} from '../../constants.js'
import log from '../../utils/logger.js'

let cxf
let gameEventTrigger

function registerUpdatePay() {
    cxf.on('124', () => {}) // 124 - register the event handler for PAYMENT_DATA server command command
    cxf.on(BigFarm.UPDATE_PAY, (eventData) => {
        const [paymentData] = eventData
        gameEventTrigger(AdBannerEvent.UPDATE_PAY, paymentData)
    })
}

const registerCustomGameHandlers = (context, rootGameEventTrigger) => {
    log.debug(`BF - registerCustomGameHandlers`)
    cxf = context
    gameEventTrigger = rootGameEventTrigger

    registerUpdatePay()
}

const bfController = {
    registerCustomGameHandlers
}

export default bfController
